import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { appStore } from '../../../../state/app';
import { concatItems } from '../../../../utils/helpers';

const Organization = () => {
  const translate = useIntl();
  const { state } = useContext(appStore);
  const { app } = state;
  const { profile } = app;
  return (
    <div className="settings__org">
      <div className="settings__org-wrapper">
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field1' })}</span>
          {' '}
          {profile?.name}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field2' })}</span>
          {' '}
          {profile?.contact_person}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field3' })}</span>
          {' '}
          {profile?.account_id}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field4' })}</span>
          {' '}
          {profile?.email}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field5' })}</span>
          {' '}
          {profile?.description}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field6' })}</span>
          {' '}
          {profile?.website}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field7' })}</span>
          {' '}
          {profile?.short_description}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field8' })}</span>
          {' '}
          {concatItems(profile?.countries)}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field9' })}</span>
          {' '}
          {concatItems(profile?.types)}
        </div>
        <div className="settings__org-field">
          <span>
            {translate.formatMessage({ id: 'settings.tab1.field10' })}
            {' '}
          </span>
          {profile?.days_in_project}
        </div>
        <div className="settings__org-field">
          <span>{translate.formatMessage({ id: 'settings.tab1.field11' })}</span>
          {' '}
          {new Date(profile?.verifiedDate).toLocaleString()}
        </div>
      </div>

    </div>
  );
};

export default Organization;
